import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  skipBtn: {
    marginTop: -theme.spacing(4),
    width: 152,
    height: 40,
  },
}));
